import EventEmitter from 'events'


export default class PointerAnimation extends EventEmitter {
  constructor() {
    super()
    this.target = null;
    this.pointerX = 0;
    this.pointerY = 0;
    this.currentX = 0;
    this.currentY = 0;
    this.x = 0;
    this.y = 0;
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;

    this.acceleration = {
      x: 10,
      y: 20,
      z: 10
    };

    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });

    document.addEventListener('mousemove', (e) => {
      this.pointerX = e.clientX;
      this.pointerY = e.clientY;
    });

    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    });

    this.update();
  }
  update() {
    requestAnimationFrame(() => {
      this.update();
    });
    this.currentX = this.currentX + (this.pointerX - this.currentX) * 0.05;
    this.currentY = this.currentY + (this.pointerY - this.currentY) * 0.05;
    this.x = (this.currentX / this.windowWidth - 0.5) * 2;
    this.y = (this.currentY / this.windowHeight - 0.5) * 2;
    if(this.target) {
      this.target.style.transform = `
      translate3d(0%, 0%, -50px)
      rotateX(${this.y * this.acceleration.y }deg)
      rotateY(${this.x * this.acceleration.x}deg)
      `;
    }

  }

  init() {
    this.target = document.querySelector('.js-pointerAnimation');
  }
}
